import React, {Dispatch, SetStateAction} from 'react';
import ToFortresTransferForm
    from "../../../../../components/ToFortresTransferForm/ToFortresTransferForm";


type PropsType = {
    setCurrent: Dispatch<SetStateAction<number>>
    setTransferData: Dispatch<SetStateAction<any>>
}

const ToAnFortresStepOne = (props: PropsType) => {

    return (
        <ToFortresTransferForm
            setCurrent={props.setCurrent}
            setTransferData={props.setTransferData}
        />
    );
};

export default ToAnFortresStepOne;
